import { useTranslations } from './useTranslations';

export const useProductMeta = (meta = {}, alreadyTranslated) => {
  const { t } = useTranslations();
  let yarnWeight = '';
  let patternType = '';
  let yarnComposition = '';
  let subtitle = '';
  let designers = '';

  const isAPattern = meta.entity_type === 'pattern';

  const getHighlight = () => {
    if (isAPattern) {
      return patternType;
    } else {
      return yarnWeight;
    }
  };

  const getShortDescription = () => {
    if (isAPattern) {
      return designers || subtitle;
    } else {
      return subtitle || yarnComposition;
    }
  };

  const setYarnWeight = () => {
    const yarnWeightCategory = meta?.yarn_weight_category;

    if (yarnWeightCategory) {
      if (alreadyTranslated) {
        yarnWeight = yarnWeightCategory;
      } else {
        yarnWeight = t(`product.yarn_weight.${yarnWeightCategory}`);
      }
    }
  };

  const setPatternMeta = () => {
    if (isAPattern) {
      if (meta.designer) {
        designers = Array.isArray(meta.designer)
          ? meta.designer.join(', ')
          : meta.designer;
      }

      if (meta.pattern_kind) {
        patternType = Array.isArray(meta.pattern_kind)
          ? meta.pattern_kind.join(', ')
          : meta.pattern_kind;
      }
    }
  };

  const setProductMeta = () => {
    if (!isAPattern) {
      yarnComposition = meta.yarn_composition;
      subtitle = meta.subtitle;
    }
  };

  setYarnWeight();
  setPatternMeta();
  setProductMeta();

  return {
    yarnWeight,
    patternType,
    yarnComposition,
    subtitle,
    designers,
    getHighlight,
    getShortDescription
  };
};
